import apiClient from './apiClient';

export async function fetchAnalysisJobs() {
  const { data } = await apiClient.get('/malware-analysis/jobs');
  return data;
}

export async function submitSample(filename, sha256) {
  const payload = { filename };
  if (sha256) payload.sha256 = sha256;
  const { data } = await apiClient.post('/malware-analysis/analyze', payload);
  return data;
}
